import React from 'react';

import { Small } from 'components/Typography';
import Layouts from 'layouts/index';

const CellComponent = ({ content, smallTextAlign = 'left', ...props }) => (
  <Layouts.Flexbox
    flexDirection="column"
    height="35px"
    justifyContent="center"
    {...props}
  >
    <Small mb={0} lineHeight="1" fontWeight="400" textAlign={smallTextAlign}>
      {content}
    </Small>
  </Layouts.Flexbox>
);

const Cell = React.memo(CellComponent);

export default Cell;
